import { Popover, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { useSession } from "next-auth/react";
import { slugify } from "@/lib/helpers";
import ShareLinks from "./share";
import Icon from "../icons/icon";
import Share from "../icons/lib/share";
import Upload from "../icons/lib/upload";

import { ACCOUNT_PROFILE } from "@/constants/routes";

interface SharePopoverProps {
  id?: string;
  artistSocials: any;
  fillColor?: string;
  disabled?: boolean;
  openLink?: boolean;
  className?: string;
}

export default function SharePopover({
  id,
  artistSocials,
  fillColor = "black",
  disabled = false,
  openLink = false,
  className,
}: SharePopoverProps) {

  const session = useSession();

  const handleOpenLink = () => {
    window.open(getShareUrl(), '_blank');
  };

  const getShareUrl = () => {
    if (window.location.href.includes(ACCOUNT_PROFILE)) {
      return window.location.href.replace(/\/account\/profile/,`/creators/${slugify(session.data?.user.artist.name)}/${session.data?.user.artistId}`);
    } else {
      return `${window.location.href}`;
    }
  };

  return (
    <div className="flex flex-row">
      <Popover className={`relative h-full ${className ?? ""}`}>
        {({ open }) => (
          <>
            <Popover.Button id={id} disabled={disabled}>
              <Icon icon={Share} className={fillColor} />
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="z-20 mt-6 w-96 right-[-8rem] -translate-x-1/2 transform px-4 sm:px-0 fixed">
                <div className="overflow-hidden rounded-2xl shadow-lg ring-opacity-5">
                  <div className="relative bg-white p-7">
                    <ShareLinks
                      artistSocials={artistSocials}
                    />
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
      {openLink && (
        <button onClick={handleOpenLink}>
          <Icon icon={Upload} className={`ml-5 ${fillColor}`} />
        </button>
      )}
    </div>
  );
}
